<section class="atw-page my-chats-page" [class.chat-fullscreen]="isDetailView">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>

  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>{{ 'atw.myChats.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.myChats.title' | transloco }}</h2>
        <p>{{ 'atw.myChats.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="chats-toolbar" *ngIf="!isDetailView">
      <strong>
        {{ 'atw.myChats.count' | transloco: { count: chats.length } }}
      </strong>

      <button type="button" class="refresh-btn" (click)="loadChats()">
        {{ 'atw.myChats.refresh' | transloco }}
      </button>
    </div>

    <div *ngIf="isLoading" class="chat-state-card">
      <div class="loader"></div>
      <p>{{ 'atw.myChats.loading' | transloco }}</p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="chat-error-card">
      <p>{{ errorMessage }}</p>
      <button type="button" (click)="retryLoad()">
        {{ 'atw.myChats.retry' | transloco }}
      </button>
    </div>

    <div
      *ngIf="!isLoading && !isDetailView && !errorMessage && !chats.length"
      class="chat-state-card"
    >
      <h3>{{ 'atw.myChats.emptyTitle' | transloco }}</h3>
      <p>{{ 'atw.myChats.emptyText' | transloco }}</p>
    </div>

    <div *ngIf="!isLoading && !isDetailView && chats.length" class="chats-list">
      <article
        class="chat-ticket-card"
        *ngFor="let chat of chats; trackBy: trackByChatId"
      >
        <button
          type="button"
          class="chat-ticket-summary"
          (click)="openChat(chat.id)"
        >
          <span class="chat-ticket-icon">💬</span>

          <span class="chat-ticket-main">
            <strong>
              {{ 'atw.myChats.conversationTitle' | transloco: { id: chat.id } }}
            </strong>
            <small>{{ getMessageText(getLatestMessage(chat)) }}</small>
          </span>

          <span class="chat-ticket-meta">
            <b [class]="'status-' + chat.status">
              {{ getStatusLabel(chat.status) }}
            </b>
            <small>{{ formatDate(chat.last_message_at || chat.updated_at) }}</small>
          </span>
        </button>
      </article>
    </div>

    <article
      *ngIf="!isLoading && isDetailView && selectedChat"
      class="chat-detail-view"
    >
      <div class="chat-detail-head">
        <button
          type="button"
          class="back-btn secondary-btn"
          (click)="backToChats()"
        >
          {{ 'atw.myChats.back' | transloco }}
        </button>

        <div>
          <span class="chat-ticket-icon">💬</span>
          <h3>
            {{
              'atw.myChats.conversationTitle'
                | transloco: { id: selectedChat.id }
            }}
          </h3>
          <p>{{ formatDate(selectedChat.last_message_at || selectedChat.updated_at) }}</p>
        </div>

        <b [class]="'status-' + selectedChat.status">
          {{ getStatusLabel(selectedChat.status) }}
        </b>
      </div>

      <div class="chat-ticket-info">
        <span>
          {{
            'atw.myChats.messageCount'
              | transloco: { count: getDisplayedMessagesCount(selectedChat) }
          }}
        </span>
        <span>
          {{
            'atw.myChats.accountType'
              | transloco: { type: selectedChat.user_type }
          }}
        </span>
      </div>

      <div
        #messagesScroller
        class="chat-messages-list detail-messages"
        *ngIf="getDisplayedMessages(selectedChat).length; else noDetailMessages"
      >
        <div
          class="chat-message-row"
          *ngFor="let message of getDisplayedMessages(selectedChat); trackBy: trackByMessageId"
          [class.from-user]="message.sender_type === 'user'"
        >
          <div>
            <strong>{{ getSenderLabel(message.sender_type) }}</strong>
            <p>{{ getMessageText(message) }}</p>
            <small>{{ message.time || formatDate(message.created_at) }}</small>
          </div>
        </div>
      </div>

      <ng-template #noDetailMessages>
        <p class="empty-messages">
          {{ 'atw.myChats.noMessages' | transloco }}
        </p>
      </ng-template>

      <form class="chat-compose" (ngSubmit)="sendMessage()">
        <input
          type="text"
          name="detailMessage"
          [(ngModel)]="detailMessageDraft"
          [disabled]="isSendingMessage || selectedChat.status === 'closed'"
          [placeholder]="'atw.myChats.placeholder' | transloco"
          autocomplete="off"
        />

        <button
          type="submit"
          [disabled]="
            !detailMessageDraft.trim() ||
            isSendingMessage ||
            selectedChat.status === 'closed'
          "
        >
          {{
            isSendingMessage
              ? ('atw.myChats.sending' | transloco)
              : ('atw.myChats.send' | transloco)
          }}
        </button>
      </form>
    </article>
  </div>
</section>
